import { GamesList } from './GamesList';
import { useRoles, userRoleIsAtLeast } from 'hooks';
import { Heading, Tabs, TabPanels, TabPanel } from '@chakra-ui/react';
import { GamesTabMenu } from './GamesTabMenu';
import { useRouter } from 'next/router';
interface GamesContainerProps {
  activeFilter: string;
  assumedUserName?: string;
  currentPage: number;
  games: any[];
  isMobile: boolean;
  isPending?: boolean;
  managedGames: any[];
  numberOfRows: number;
  onPageChange: (pageNumber: number) => void;
  onWinningsClick?: (event: any) => void;
  totalManaged: number;
  totalGames: number;
}
export const GamesContainer = ({
  activeFilter,
  assumedUserName,
  currentPage,
  games,
  isMobile,
  isPending,
  managedGames,
  numberOfRows,
  onPageChange,
  onWinningsClick,
  totalManaged,
  totalGames
}: GamesContainerProps) => {
  const router = useRouter();
  const {
    isManagerView
  } = router.query;
  const userRoles = useRoles();
  const atLeastTeamManager = userRoleIsAtLeast({
    userRole: userRoles,
    requiredRole: 'team_manager'
  });
  const commonProps = {
    activeFilter,
    currentPage,
    isMobile,
    isPending,
    numberOfRows,
    onPageChange,
    onWinningsClick
  };
  const handleTabChange = async (index: number) => {
    const query = {
      ...router.query
    };
    if (index === 1) {
      query.isManagerView = 'true';
    } else {
      delete query.isManagerView;
    }
    await router.push({
      pathname: router.pathname,
      query
    }, undefined, {
      shallow: true
    });
  };
  if (!atLeastTeamManager) {
    return <>
        <Heading as="h2" fontSize="2xl" marginBottom={2} marginTop={2} paddingX={{
        base: 0,
        lg: 2,
        xl: 6
      }} style={{
        color: 'var(--gp-heading-color)'
      }}>
          My Games
        </Heading>
        <GamesList {...commonProps} totalEntries={totalGames} games={games} managerView={false} />
      </>;
  }
  return <Tabs variant="soft-rounded" isLazy defaultIndex={isManagerView === 'true' ? 1 : 0} onChange={handleTabChange} data-sentry-element="Tabs" data-sentry-component="GamesContainer" data-sentry-source-file="GamesContainer.tsx">
      <GamesTabMenu assumedUserName={assumedUserName} isMobile={isMobile} data-sentry-element="GamesTabMenu" data-sentry-source-file="GamesContainer.tsx" />
      <TabPanels minHeight="300px" paddingTop={4} data-sentry-element="TabPanels" data-sentry-source-file="GamesContainer.tsx">
        <TabPanel data-sentry-element="TabPanel" data-sentry-source-file="GamesContainer.tsx">
          <GamesList {...commonProps} totalEntries={totalGames} games={games} managerView={false} data-sentry-element="GamesList" data-sentry-source-file="GamesContainer.tsx" />
        </TabPanel>
        <TabPanel data-sentry-element="TabPanel" data-sentry-source-file="GamesContainer.tsx">
          <GamesList {...commonProps} totalEntries={totalManaged} games={managedGames} managerView={true} data-sentry-element="GamesList" data-sentry-source-file="GamesContainer.tsx" />
        </TabPanel>
      </TabPanels>
    </Tabs>;
};